import request from '../../api/request';
import { AsynOptionsFieldsOrigin, OptionsResponse } from './types';

const ENDPOINTS = {
  GET_ASYNC_OPTIONS_FIELDS: (from: AsynOptionsFieldsOrigin) =>
    `maintainers-portal/student-file-async-options-fields/${from}`,
};

export const getAsyncOptionsFields = (from: AsynOptionsFieldsOrigin) => {
  return request<OptionsResponse>(ENDPOINTS.GET_ASYNC_OPTIONS_FIELDS(from));
};
